// caesar-caps.ts — the Caesar auto-paper guardrails + the pure cap math.
// DEPENDENCY-FREE at runtime (the PaperTrade import is type-only and erased),
// so the node test suite exercises these directly. caesar-autotrade.ts
// re-exports CAESAR_CAPS for its nine existing importers.
import type { PaperTrade } from './ledger';

// Owner-Only guardrails mirrored from datahub/villicus/policy.json BASE_POLICY
// (the datahub/villicus/ directory path is kept for packaging compatibility).
// The Settings panel shows these read-only and clamps config to them.
export const CAESAR_CAPS = {
  mode: 'paper' as const,
  maxOpenPositions: 3,
  maxTradesPerDay: 5,
  maxTradeDollars: 100,
  maxDailyLoss: 100,
};

// A Caesar auto-logged paper trade (the persisted 'auto paper' notes prefix is a
// stable data format — see ledgerStats' account split).
export const isAutoTrade = (t: PaperTrade) => typeof t.notes === 'string' && /^auto paper/i.test(t.notes);

// Pure daily-cap check: true when fewer than `cap` auto trades were recorded on
// the same UTC day as `now`. CAESAR_CAPS.maxTradesPerDay was previously declared
// + displayed as a guardrail but enforced nowhere — a declared cap must be a
// real cap (red-team finding, 2026-07-04). Malformed recordedAt rows are ignored.
export function underDailyAutoCap(trades: PaperTrade[], cap: number, now = new Date()): boolean {
  const day = now.toISOString().slice(0, 10);
  const today = trades.filter(
    (t) => isAutoTrade(t) && typeof t.recordedAt === 'string' && t.recordedAt.slice(0, 10) === day,
  );
  return today.length < cap;
}
